module.exports = {
      id: "video-whitebg-usage",
      viewBox: "0 0 90 90",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#video-whitebg",
      toString: function () {
        return this.url;
      }
    }